import {
  INDIAN_POKER_MIN_STARTING_CHIPS,
  INDIAN_POKER_STARTING_CHIPS,
} from "@cloudnest/indian-poker-engine";
import { useEffect, useRef, useState } from "react";
import type { CreateGameFormProps } from "../../game-registry";

export function IndianPokerCreateGameForm({
  onConfigChange,
}: CreateGameFormProps) {
  const [startingChips, setStartingChips] = useState(
    String(INDIAN_POKER_STARTING_CHIPS),
  );
  const onConfigChangeRef = useRef(onConfigChange);
  onConfigChangeRef.current = onConfigChange;

  useEffect(() => {
    const chips = Number(startingChips);
    const config: Record<string, unknown> = {};

    if (Number.isFinite(chips)) {
      config.startingChips = Math.max(
        INDIAN_POKER_MIN_STARTING_CHIPS,
        Math.trunc(chips),
      );
    } else {
      config.startingChips = INDIAN_POKER_STARTING_CHIPS;
    }

    onConfigChangeRef.current(config);
  }, [startingChips]);

  return (
    <section className="rounded-md border border-border-subtle bg-surface-secondary p-3">
      <div className="mb-3">
        <div className="font-semibold text-sm text-text-primary">
          인디언 포커 설정
        </div>
        <div className="mt-1 text-text-muted text-xs">
          각 플레이어가 시작할 기본 토큰 수를 정합니다.
        </div>
      </div>
      <label className="grid gap-1.5 text-sm">
        <span className="font-semibold text-text-secondary">시작 토큰</span>
        <input
          className="rounded-md border border-border-primary bg-surface-primary px-3 py-2 text-text-primary"
          min={INDIAN_POKER_MIN_STARTING_CHIPS}
          type="number"
          value={startingChips}
          onChange={(event) => setStartingChips(event.currentTarget.value)}
        />
      </label>
    </section>
  );
}
